// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__S75bM","header":"PatientQuestionnaire_header__1VeYc","info":"PatientQuestionnaire_info__1wUZB"};